import { render, staticRenderFns } from "./home-clipfly.vue?vue&type=template&id=1d52b5a1&scoped=true"
import script from "./home-clipfly.vue?vue&type=script&lang=ts"
export * from "./home-clipfly.vue?vue&type=script&lang=ts"
import style0 from "./home-clipfly.vue?vue&type=style&index=0&id=1d52b5a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52b5a1",
  null
  
)

export default component.exports